import { useCallback, useSyncExternalStore } from "react";

export const MOBILE_BREAKPOINT = 850;

/**
 * Ширина экрана — внешний источник данных для React, поэтому читаем её через
 * useSyncExternalStore, а не через useState + useEffect: это избавляет от
 * лишнего рендера после монтирования и корректно работает при SSR
 * (на сервере считаем, что экран не мобильный).
 */
export function useIsMobile() {
  const subscribe = useCallback((onChange: () => void) => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  const getSnapshot = useCallback(() => window.innerWidth < MOBILE_BREAKPOINT, []);
  const getServerSnapshot = useCallback(() => false, []);

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
